import React from "react";

import "./BannersBetzulaAnimated.scss";

import banner1Webp from "accets/mock/1-new.webp";
import banner1Png from "accets/mock/1-new.png";

import banner2Webp from "accets/mock/2-new.webp";
import banner2Png from "accets/mock/2-new.png";

import banner3Webp from "accets/mock/3-new.webp";
import banner3Png from "accets/mock/3-new.png";

import banner4Webp from "accets/mock/4-new.webp";
import banner4Png from "accets/mock/4-new.png";

import banner5Webp from "accets/mock/5-new.webp";
import banner5Png from "accets/mock/5-new.png";

import banner6Webp from "accets/mock/6-new.webp";
import banner6Png from "accets/mock/6-new.png";

import {Link} from "react-router-dom";
import {useTypeSelector} from "srcm/hooks/useTypeSelector";

const BannersBetzulaAnimated = () => {
  const lang = useTypeSelector(
    (data) => data.settingsReducer.language.languageShort
  );
  return (
    <div className="hm-row-bc   " style={{gridTemplateColumns: "12fr"}}>
      <div className="pb-component-wrapper">
        <div className="product-banner-container-bc col-5 product-banner-without-titles">
          <Link
            target="_self"
            className="product-banner-info-bc product-banner-bc"
            to={`/${lang}/casino/slots/-1?openGames=softswiss&gameNames=plink`}
          >
            <picture>
              <source srcSet={banner1Webp} type="image/webp"/>
              <source srcSet={banner1Png} type="image/png"/>
              <img
                loading="lazy"
                src={banner1Png}
                className="sdr-image-bc"
                width={236}
                height={331}
                alt=""
                title=""
              />
            </picture>
          </Link>
          <Link
            target="_self"
            className="product-banner-info-bc product-banner-bc"
            to={`/${lang}/casino/slots/-1?openGames=spribe&gameNames=aviator`}
          >
            <picture>
              <source srcSet={banner2Webp} type="image/webp"/>
              <source srcSet={banner2Png} type="image/png"/>
              <img
                loading="lazy"
                src={banner2Png}
                className="sdr-image-bc"
                width={236}
                height={331}
                alt=""
                title=""
              />
            </picture>
          </Link>
          <Link
            target="_self"
            className="product-banner-info-bc product-banner-bc"
            to={`/${lang}/casino/slots/-1?openGames=fazi&gameNames=fazi-classicluckyspin`}
          >
            <picture>
              <source srcSet={banner3Webp} type="image/webp"/>
              <source srcSet={banner3Png} type="image/png"/>
              <img
                loading="lazy"
                src={banner3Png}
                className="sdr-image-bc"
                width={236}
                height={331}
                alt=""
                title=""
              />
            </picture>
          </Link>
          <Link
            target="_self"
            className="product-banner-info-bc product-banner-bc"
            to={`/${lang}/casino/slots/-1?openGames=habanero&gameNames=hb-sgcoyotecrash`}
          >
            <picture>
              <source srcSet={banner4Webp} type="image/webp"/>
              <source srcSet={banner4Png} type="image/png"/>
              <img
                loading="lazy"
                src={banner4Png}
                className="sdr-image-bc"
                width={236}
                height={331}
                alt=""
                title=""
              />
            </picture>
          </Link>
          <Link
            target="_self"
            className="product-banner-info-bc product-banner-bc"
            to={`/${lang}/casino/slots/-1?openGames=kagaming&gameNames=ka-blastman`}
          >
            <picture>
              <source srcSet={banner5Webp} type="image/webp"/>
              <source srcSet={banner5Png} type="image/png"/>
              <img
                loading="lazy"
                src={banner5Png}
                className="sdr-image-bc"
                width={236}
                height={331}
                alt=""
                title=""
              />
            </picture>
          </Link>
          <Link
            target="_self"
            className="product-banner-info-bc product-banner-bc"
            to={`/${lang}/casino/slots/-1?openGames=spribe&gameNames=aviator`}
          >
            <picture>
              <source srcSet={banner6Webp} type="image/webp"/>
              <source srcSet={banner6Png} type="image/png"/>
              <img
                loading="lazy"
                src={banner6Png}
                className="sdr-image-bc"
                width={236}
                height={331}
                alt=""
                title=""
              />
            </picture>
          </Link>
        </div>
      </div>
    </div>
  );
};

export {BannersBetzulaAnimated};
